const funcs = {
    logAndGetError: function(handle, e) {
        funcs.logError(handle, e);

        // console.log(e, e.message);

        if(e.response) {
            if(e.response.status === 502) {
                return "The server is currently updating. Content will be updated and synced when the server is back online."
            }
            if(e.response.data) {
                if(e.response.data.message) {
                    return e.response.data.message;
                } else if(e.response.data.detail) {
                    return e.response.data.detail;
                } else if(e.response.data.info) {
                    return e.response.data.info;
                } 
                return e.response.data;
            }
        }
        return "An error has occured ";
    },
    logError: function(handle, e) {
        handle.$store.commit('addErrorLog', JSON.stringify(e.message ? e.message : e));
    },
    check401And498: function (handle, e) {
        if(e && e.response && e.response.status && (e.response.status === 401 || e.response.status === 498)) {
            window.location.href = handle.$config.get('basePathFiles') + "logout?redirect=" + handle.$router.currentRoute.path;
        }
    },
    check502: function (handle, e) {
        if(e && e.response && e.response.status && e.response.status === 502) {
            window.location.href = handle.$config.get('basePathFiles') + "502?redirect=" + handle.$router.currentRoute.path;
        }
    },
    check498: function(handle, e) {}
}

export default funcs
